// src/pages/geral/leads/LeadCaptacaoDetalhesModal.js
import React from 'react';
import { FaEye } from 'react-icons/fa';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import { useLeadCaptacao } from '../../../contexts/geral/LeadCaptacaoContext';
import { formatarDataLead, textoLead } from '../../../models/geral/LeadCaptacao';

const GrupoDetalhes = ({ titulo, campos }) => (
  <section>
    <h3>{titulo}</h3>
    <dl className="leads-detalhes-campos">
      {campos.map(([rotulo, valor]) => (
        <div key={rotulo}><dt>{rotulo}</dt><dd>{textoLead(valor)}</dd></div>
      ))}
    </dl>
  </section>
);

const LeadCaptacaoDetalhesModal = () => {
  const { detalhesAberto, selecionado: lead, carregandoDetalhes, erroDetalhes, fecharDetalhes } = useLeadCaptacao();
  return (
    <ModalContainer show={detalhesAberto} onHide={fecharDetalhes} largura="900px"
      variant="busca" contentClassName="leads-detalhes-modal">
      <ModalHeader title="Detalhes do lead" subtitle={lead?.nomeCompleto} icon={FaEye} onHide={fecharDetalhes} />
      <ModalBody>
        {carregandoDetalhes && <p role="status">Carregando detalhes...</p>}
        {erroDetalhes && <p role="alert">{erroDetalhes}</p>}
        {lead && (
          <>
            <GrupoDetalhes titulo="Contato e empresa" campos={[
              ['ID', lead.id], ['Nome completo', lead.nomeCompleto], ['Telefone', lead.telefone],
              ['Município/UF', lead.localidade], ['Ramo', lead.ramoDescricao], ['Tipo de empresa', lead.tipoDescricao],
              ['Dispositivos de uso', lead.dispositivosDescricao], ['Intenção', lead.intencaoDescricao],
            ]} />
            <GrupoDetalhes titulo="Qualificação do negócio" campos={[
              ['Segmentos de alimentação', lead.segmentosAlimentacaoDescricao],
              ['Formas de atendimento', lead.formasAtendimentoDescricao],
              ['Principais desafios', lead.principaisDesafiosDescricao],
            ]} />
            <GrupoDetalhes titulo="Cadastro e consentimento" campos={[
              ['Data do cadastro (São Paulo)', formatarDataLead(lead.dataCadastro)],
              ['Consentimento para contato', lead.consentimentoContato ? 'Sim' : 'Não'],
              ['Versão do consentimento', lead.versaoConsentimento],
              ['Data do consentimento (São Paulo)', formatarDataLead(lead.dataConsentimento)],
              ['ID do envio', lead.idEnvio],
            ]} />
            <GrupoDetalhes titulo="Origem e campanha" campos={[
              ['Página de origem', lead.paginaOrigem], ['UTM Source', lead.utmSource], ['UTM Medium', lead.utmMedium],
              ['UTM Campaign', lead.utmCampaign], ['UTM Content', lead.utmContent], ['UTM Term', lead.utmTerm],
              ['Gclid', lead.gclid], ['Gbraid', lead.gbraid], ['Wbraid', lead.wbraid],
            ]} />
          </>
        )}
      </ModalBody>
      <ModalFooter><button type="button" className="btn btn-secondary" onClick={fecharDetalhes}>Fechar</button></ModalFooter>
    </ModalContainer>
  );
};

export default LeadCaptacaoDetalhesModal;
